<div class="counter-box">
    <div class="counter-item">
      <div class="description">Anslutna leverantörer</div>
      <div class="number">{{ formatNumber(currentCount1) }}</div>
    </div>
    <div class="counter-item">
      <div class="description">Aktiva BRF:er</div>
      <div class="number">{{ formatNumber(currentCount2) }}</div>
    </div>
  </div>  